module.exports = __webpack_public_path__ + "img/topic-active-detail.dee157d1.png";